<form (submit)="onSave()">
  <insurance-editor [insurances]="insurances" [forceInsure]="true"></insurance-editor>
  <button type="submit" class="save-btn">Сохранить</button>
</form>
